import { render, staticRenderFns } from "./UnBindPage.vue?vue&type=template&id=533711b6&scoped=true&"
import script from "./UnBindPage.vue?vue&type=script&lang=js&"
export * from "./UnBindPage.vue?vue&type=script&lang=js&"
import style0 from "./UnBindPage.vue?vue&type=style&index=0&id=533711b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533711b6",
  null
  
)

export default component.exports